import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=4ce23868"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports